
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	lista: [],
	listaTipo: [],
	listaStatus: [
		{ id: 'pendente', valor: 'Pendente' },
		{ id: 'aprovada', valor: 'Aprovada' },
		{ id: 'reprovada', valor: 'Reprovada' }
	],
	listaMotorista: [],
	listaUsuario: [],
	listaUsuarioKmm: [],
	listaCompetencias: (() => {
		const lista = [{ id: 0, valor: 'Período Aberto' }];

		const hoje = new Date();
		let ano = 2026;
		let mes = 1;

		while (
			ano < hoje.getFullYear() ||
			(ano === hoje.getFullYear() && mes <= hoje.getMonth() + 1)
		) {
			lista.push({
				id: Number(`${ano}${String(mes).padStart(2, '0')}`),
				valor: `${String(mes).padStart(2, '0')}/${ano}`
			});

			mes++;
			if (mes > 12) {
				mes = 1;
				ano++;
			}
		}

		return lista;
	})(),
	filtro: {
		competencia: '0',
		data_inicial: DateFormat.getDataAnterior(30),
		data_final: DateFormat.getDataAtual(),
		ids_status: ['pendente']
	}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'OCORRENCIA_AUTOMATICA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'OCORRENCIA_AUTOMATICA_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'OCORRENCIA_AUTOMATICA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'OCORRENCIA_AUTOMATICA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'OCORRENCIA_AUTOMATICA_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

        case 'OCORRENCIA_AUTOMATICA_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaMotorista: action.payload.data
			};

		case 'OCORRENCIA_AUTOMATICA_USUARIO_SELECT_LISTADO':
			return {
				...state,
				listaUsuario: action.payload.data
			};
		
		case 'OCORRENCIA_AUTOMATICA_USUARIO_KMM_SELECT_LISTADO':
			return {
				...state,
				listaUsuarioKmm: action.payload.data
			};

        default:
            return state;
    }
}
